const ENVIRONMENT_BY_PLATFORM = Object.freeze({
  TDT03: 'https://testedt03.qa.directtalk.com.br/adminuiservices',
  TDT04: 'https://testedt04.qa.directtalk.com.br/adminuiservices',
  TDT07: 'https://testedt07.qa.directtalk.com.br/adminuiservices',
  PHMG1: 'https://hmg1-sup.directtalk.com.br/adminuiservices',
  PHMG2: 'https://hmg2-sup.directtalk.com.br/adminuiservices',
  P01: 'https://www3.directtalk.com.br/adminuiservices',
  P02: 'https://www5.directtalk.com.br/adminuiservices',
  P03: 'https://www7.directtalk.com.br/adminuiservices',
  P04: 'https://www9.directtalk.com.br/adminuiservices',
  P05: 'https://www11.directtalk.com.br/adminuiservices',
  P06: 'https://www13.directtalk.com.br/adminuiservices',
  P07: 'https://www15.directtalk.com.br/adminuiservices',
})

/**
 *
 * @param {string} plat
 * @param {boolean} localhostIgnore
 * @returns
 */
export const getAdminUiUrlByPlatform = (plat, localhostIgnore = true) => {
  if (window.location.href.includes('localhost') && localhostIgnore) return ''
  return ENVIRONMENT_BY_PLATFORM[plat]
}
